import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import querystring from "querystring-es3";
import cookies from "browser-cookies";
import { logOutUser } from "../../../features/auth/actions";

import * as generalActions from "../actions";
import * as siteDataActions from "../../sitedata/actions";
import * as soloActions from "../../soloLookup/actions";
import baseViewStateToProps from "../selectors";

import BaseLayout from "./BaseLayout";

const BaseView = props => {
  const { loggedIn, location, history, actions, allowedAccess } = props;

  useEffect(() => {
    if (loggedIn) {
      actions.checkRebuildStatus();
      actions.checkDevMode();
      if (allowedAccess) {
        actions.siteDataFetch();
        actions.soloUIDFetch();
      }
    }
  }, [loggedIn]);

  const handleErrorModalClose = () => {
    actions.closeErrorModal();
  };

  const handleChangeWorkarea = () => {
    const { pathname, search } = location;
    const { push } = history;
    const query = querystring.parse(search.replace("?", ""));
    push(`/portal2/workarea?next=${query.next ?? pathname}`);
  };

  const handleChangeOrganization = () => {
    const { pathname, search } = location;
    const { push } = history;
    const query = querystring.parse(search.replace("?", ""));
    push(`/portal2/organization?next=${query.next ?? pathname}`);
  };

  const handleToggleAppDrawer = () => {
    actions.appDrawerToggle(!props.appDrawerOpen);
  };

  const handleLogOutUser = async () => {
    cookies.erase("authHeaders");
    logOutUser();
    const {
      history: { push }
    } = props;
    push("/portal2");
  };

  return (
    <BaseLayout
      {...props}
      onChangeDevMode={mode => actions.setMode(mode)}
      onErrorModalClose={() => handleErrorModalClose()}
      onChangeWorkarea={() => handleChangeWorkarea()}
      onChangeOrganization={() => handleChangeOrganization()}
      onToggleAppDrawer={() => handleToggleAppDrawer()}
      onLogout={() => handleLogOutUser()}
    />
  );
};

BaseView.propTypes = {
  loggedIn: PropTypes.bool.isRequired,
  allowedAccess: PropTypes.bool.isRequired,
  appDrawerOpen: PropTypes.bool.isRequired,
  workarea: PropTypes.string,
  organization: PropTypes.string,
  rebuildRunning: PropTypes.bool,
  location: PropTypes.shape({
    search: PropTypes.string,
    pathname: PropTypes.string.isRequired
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  actions: PropTypes.shape({
    checkDevMode: PropTypes.func.isRequired,
    checkRebuildStatus: PropTypes.func.isRequired,
    setMode: PropTypes.func.isRequired,
    closeErrorModal: PropTypes.func.isRequired,
    appDrawerToggle: PropTypes.func.isRequired,
    siteDataFetch: PropTypes.func.isRequired,
    soloUIDFetch: PropTypes.func.isRequired
  }).isRequired
};

BaseView.defaultProps = {
  workarea: undefined,
  organization: undefined,
  rebuildRunning: false
};

const mapDispatchToProps = dispatch => ({
  actions: {
    ...bindActionCreators(generalActions, dispatch),
    ...bindActionCreators(siteDataActions, dispatch),
    ...bindActionCreators(soloActions, dispatch)
  }
});

export default withRouter(
  connect(baseViewStateToProps, mapDispatchToProps)(BaseView)
);
